import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { AuthService } from "../../auth/auth.service";
import { HttpStatusCode } from "../meta/http-status-code.enum";

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // TODO: Only use the token. "this.authService.user.token"
    // TODO: Use Bearer scheme (as recomended by jwt and community) `Bearer ${this.authService.user.token}`

    // NOTE: Token Verification is a form of Authentication; not authorization.
    const authToken = JSON.stringify(this.authService.user);
    const authReq = req.clone({ headers: req.headers.set("Authorization", authToken) });

    return next.handle(authReq).pipe(
      tap(
        event => { },
        error => {
          if (error instanceof HttpErrorResponse) {
            switch (error.status) {
              case HttpStatusCode.InvalidToken:
                this.authService.logout();
                break;
              default:
                // do nothing;
                break;
            }
          }
        }
      )
    );
  }
}
